import React from "react"
import Layout from "../components/layout"
import SearchBar from "../components/searchbar"
import SEO from "../components/seo"
import { Link } from "gatsby"

import "../components/style.css"

const IndexPage = () => (
  <>
    <Layout>
      <SEO
        title="Search All Facebook Marketplace - Worldwide Marketplace Search"
        description="Search Facebook Marketplace worldwide. Find items for sale across multiple countries. Remove the 100-mile boundary and search globally."
        keywords="Facebook Marketplace, worldwide search, global marketplace, items for sale, international shopping, marketplace search"
        pathname="/"
      />
      <div className="container">
        <div className="centered">
          <div className="style1">
            <h1 className="style1"> Search All Facebook Marketplace </h1>
          </div>
          <div className="style2">Search items for sale in the entire world</div>
          <Link to="/about">
            <input type="submit" value="Learn More" className="button1" />
          </Link>
        </div>
      </div>
      <div className="search-section">
        <div className="search-location">
          <span className="current-location">Currently searching worldwide</span>
          <Link to="/United-States" className="usa-link">
            <div className="usa-note">Switch to USA</div>
          </Link>
        </div>
        <SearchBar />
      </div>
    </Layout>
  </>
)

export default IndexPage
